import React from 'react';
import PixiScaledSprite from "./PixiScaledSprite"
import PixiScaledText from "./PixiScaledText"
import PixiEndGamePlayerInfoRow from "./PixiEndGamePlayerInfoRow"
import { Container, Sprite } from '@pixi/react';
import { pixiGameUtils, FEATURE_TYPE } from '../PixiGame/PixiGameUtils'
import PixiGamePositionRibbon from "./PixiGamePositionRibbon"
// import PixiSocialSharePanel from "./PixiSocialSharePanel"

class PixiEndGameOverlay extends React.Component
{
  handleBuyMeCoffeeClick = () =>
  {
    window.open( 'https://www.buymeacoffee.com/fenderrio', '_blank' );
  }

  render()
  {
    const stageRenderData = this.props.stageRenderData;
    const playerData = this.props.playerData;
    const clientId = this.props.clientId;

    const numPlayers = playerData.playersJoined.length;

    // Combine the scores and player name info into single objects in an array
    let endGamePlayerData = [];
    let isClientPlaying = false;

    for( let idx = 0; idx < numPlayers; idx++ )
    {
      if( playerData.playersJoined[ idx ].socketID === clientId )
      {
        isClientPlaying = true;
      }

      endGamePlayerData.push(
        {
          username: playerData.playersJoined[ idx ].username,
          score: playerData.scores[ idx ],
          roadScore: playerData.roadScores[ idx ],
          cityScore: playerData.cityScores[ idx ],
          cloisterScore: playerData.cloisterScores[ idx ],
          fieldScore: playerData.fieldScores[ idx ],
          isClient: playerData.playersJoined[ idx ].socketID === clientId,
          isHuman: !playerData.playersJoined[ idx ].isBot,
          colourHex: playerData.playersJoined[ idx ].colourHex,
          colourID: playerData.playersJoined[ idx ].colourID
        }
      );
    }

    // Sort player data list by scores, highest to lowest
    endGamePlayerData.sort( ( pd1, pd2 ) => { return pd2.score - pd1.score; } );


    const renderScale = stageRenderData.scale;

    const rowSpacing = 5;
    const playerRowHeight = 65;

    const panelWidth = 800;
    const panelHeight = 170
      + ( isClientPlaying ? 60 : 0 )  // Bottom buffer used to show social Share button / buy me a coffee button
      + ( numPlayers * playerRowHeight );

    const featureIconSize = 40;

    let resultsPanelPlayerRowsContent = [];

    let yOffset = 100;
    let positionIndex = 0;
    let playerPositionIndex;

    for( let idx = 0; idx < numPlayers; idx++ )
    {
      const currentPlayerData = endGamePlayerData[ idx ];

      if( idx > 0 && currentPlayerData.score < endGamePlayerData[ idx - 1 ].score )
      {
        positionIndex++;
      }

      let playerIconSprite = pixiGameUtils.getPlayerIconSprite( currentPlayerData );

      resultsPanelPlayerRowsContent.push(
        <PixiEndGamePlayerInfoRow
          key={ "player-" + idx }
          stageRenderData={ stageRenderData }
          x={ 0 }
          y={ ( yOffset + ( playerRowHeight / 2 ) ) * renderScale }
          width={ this.panelWidth }
          height={ playerRowHeight }
          playerName={ currentPlayerData.username }
          isClientPlayerRow={ currentPlayerData.isClient }
          positionIndex={ positionIndex }
          playerIconSprite={ playerIconSprite }
          score={ currentPlayerData.score }
          roadScore={ currentPlayerData.roadScore }
          cityScore={ currentPlayerData.cityScore }
          cloisterScore={ currentPlayerData.cloisterScore }
          fieldScore={ currentPlayerData.fieldScore }
        />
      );

      if( currentPlayerData.isClient )
      {
        playerPositionIndex = positionIndex;
      }

      yOffset += playerRowHeight + rowSpacing;
    }

    return (

      <>

        {/* Background Tint - Input Blocker */ }
        <Sprite
          image={ "./ui/white_tile.png" }
          stageRenderData={ stageRenderData }
          x={ 0 }
          y={ 0 }
          width={ stageRenderData.width }
          height={ stageRenderData.height }
          anchor={ { x: 0, y: 0 } }
          tint={ 0x111111 }
          alpha={ 0.5 }
        />



        <Container
          x={ ( this.props.playScreenWidth / 2 ) - ( ( panelWidth * renderScale ) / 2 ) }
          y={ ( this.props.playScreenHeight / 2 ) - ( ( panelHeight * renderScale ) / 2 ) }
        >

          <PixiScaledSprite
            imageSrc={ "./ui/panel_bg.png" }
            isNineSlice={ true }
            cornerRadius={ 15 }
            stageRenderData={ stageRenderData }
            x={ 0 }
            y={ 0 }
            width={ panelWidth }
            height={ panelHeight }
            anchor={ { x: 0, y: 0 } } />

          <PixiScaledText
            text={ "Match Results" }
            stageRenderData={ stageRenderData }
            x={ 30 * renderScale }
            y={ 60 }
            anchor={ { x: 0, y: 1 } }
            fontSize={ 35 }
            style={ {
              fontWeight: "bold",
              fill: "#111111"
            } }
          />

          { isClientPlaying &&
            (
              <>
                <PixiScaledText
                  text={ "You came " + this.finishPositionToText( playerPositionIndex ) + ( playerPositionIndex === 0 ? "!" : "" ) }
                  stageRenderData={ stageRenderData }
                  x={ ( ( panelWidth ) - 130 ) * renderScale }
                  y={ 60 }
                  anchor={ { x: 1, y: 1 } }
                  fontSize={ 30 }
                  style={ {
                    fontWeight: "normal",
                    fill: "#111111",
                    fontStyle: "italic",
                    padding: 20 // Prevents padding
                  } }
                />
                <PixiGamePositionRibbon
                  keyName={ `position-tab-ribbon-${positionIndex}` }
                  x={ ( ( panelWidth ) - 100 ) * renderScale }
                  y={ 40 }
                  positionIndex={ playerPositionIndex }
                  stageRenderData={ stageRenderData }
                  scale={ 0.8 }
                />
              </>
            ) }

          <PixiScaledSprite
            imageSrc={ pixiGameUtils.featureTypeValueToImgURL_128x128( FEATURE_TYPE.ROAD ) }
            stageRenderData={ stageRenderData }
            x={ 340 * renderScale }
            y={ 90 }
            width={ featureIconSize }
            height={ featureIconSize }
            anchor={ { x: 0, y: 0 } } />

          <PixiScaledSprite
            imageSrc={ pixiGameUtils.featureTypeValueToImgURL_128x128( FEATURE_TYPE.CITY ) }
            stageRenderData={ stageRenderData }
            x={ 420 * renderScale }
            y={ 90 }
            width={ featureIconSize }
            height={ featureIconSize }
            anchor={ { x: 0, y: 0 } } />

          <PixiScaledSprite
            imageSrc={ pixiGameUtils.featureTypeValueToImgURL_128x128( FEATURE_TYPE.CLOISTER ) }
            stageRenderData={ stageRenderData }
            x={ 500 * renderScale }
            y={ 90 }
            width={ featureIconSize }
            height={ featureIconSize }
            anchor={ { x: 0, y: 0 } } />

          <PixiScaledSprite
            imageSrc={ pixiGameUtils.featureTypeValueToImgURL_128x128( FEATURE_TYPE.FIELD ) }
            stageRenderData={ stageRenderData }
            x={ 580 * renderScale }
            y={ 90 }
            width={ featureIconSize }
            height={ featureIconSize }
            anchor={ { x: 0, y: 0 } } />


          <PixiScaledText
            text={ "Total" }
            stageRenderData={ stageRenderData }
            x={ 680 * renderScale }
            y={ 100 }
            anchor={ { x: 0, y: 0 } }
            fontSize={ 23 }
            style={ {
              fill: "#111111"
            } }
          />


          { resultsPanelPlayerRowsContent }


          {/* Buy Me a Coffee Button */ }
          <PixiScaledSprite
            imageSrc="./meeples-buy-me-a-coffee-button.png"
            stageRenderData={ stageRenderData }
            x={ ( ( panelWidth ) - 10 ) * renderScale }
            y={ ( panelHeight - 45 ) }
            width={ 123 }
            height={ 70 }
            anchor={ { x: 1, y: 0.5 } }
            onClick={ this.handleBuyMeCoffeeClick }
            buttonMode={ true }
            interactive={ true }
            onHoverTint={ '0xdddddd' }
          />


          {/* { isClientPlaying && (
            <PixiSocialSharePanel
              stageRenderData={ stageRenderData }
              playScreenWidth={ this.props.playScreenWidth }
              playScreenHeight={ this.props.playScreenHeight }
              endGamePlayerData={ endGamePlayerData }
              clientPosition={ playerPositionIndex }
              numPlayers={ numPlayers }
              x={ ( ( panelWidth / 2 ) - 70 ) * renderScale }
              y={ ( panelHeight - 50 ) * renderScale }
              parentContainerWidth={ panelWidth }
              parentContainerHeight={ panelHeight }
            />
          ) } */}

        </Container>

      </>

    );
  }

  finishPositionToText( finishingPosition )
  {
    switch( finishingPosition )
    {
      case 0:
        return "1st";
      case 1:
        return "2nd";
      case 2:
        return "3rd";
      case 3:
        return "4th";
      case 4:
        return "5th";
      case 5:
        return "6th";
      case 6:
        return "7th";
      case 7:
      default:
        return "8th";
    }
  }
}

export default PixiEndGameOverlay;
